import type {
  CollectEffect,
  GameEffect,
  Point,
  TrayBead,
} from "@pindou/game-core";
import { flyBead } from "./flight";

export interface EffectPlaybackContext {
  readonly layer: HTMLElement;
  readonly boardCenter: (point: Point) => DOMPoint;
  readonly trayCenter: (index: number) => DOMPoint;
  readonly getTray: () => readonly TrayBead[];
  readonly setTray: (tray: readonly TrayBead[]) => void;
}

async function playCollectSegment(
  effects: readonly CollectEffect[],
  context: EffectPlaybackContext,
): Promise<void> {
  if (effects.length === 0) {
    return;
  }
  const flights = effects.map(async (effect, index) => {
    await flyBead(context.layer, {
      color: effect.color,
      from: context.boardCenter(effect.from),
      to: context.trayCenter(effect.trayIndex),
      delay: index * 28,
      duration: 330,
    });
    const bead: TrayBead = {
      beadId: effect.beadId,
      color: effect.color,
      source: effect.from,
      trayIndex: effect.trayIndex,
    };
    context.setTray([...context.getTray(), bead].sort((left, right) => left.trayIndex - right.trayIndex));
  });
  await Promise.all(flights);
}

export async function playEffects(
  effects: readonly GameEffect[],
  context: EffectPlaybackContext,
): Promise<void> {
  await playCollectSegment(effects.filter((effect): effect is CollectEffect => effect.type === "collect"), context);
}
